import masterData from "./menus/master-data/index";
import entry from "./menus/entry/items";
export default {
  menu: [
    {
      key: "menu.dashboard",
      text: "Dashboard",
      link: "/dashboard"
    },
    {
      level: 1,
      key: "title.chartOfAccount",
      keywords: "chart account",
      link: "/master-data/general-ledger/coa",
    },
    {
      text: "Document Approval",
      key: "title.documentApproval",
      level: 1,
      expanded: false,
      link: "/document-approval",
    },
    {
      level: 1,
      key: "title.dimension",
      keywords: "dimension",
      expanded: false,
      items: [
        { level: 2, key: "title.dimension", link: "/dimension/dimension-list" },
        { level: 2, key: "title.coaDimensionMatrix", link: "/dimension/coa-matrix" },
        { level: 2, key: "title.generalBudgetEntry", link: "/dimension/general-budget-entry" },
        { level: 2, key: "title.generalBudgetJournal", link: "/dimension/general-budget-journal" },
      ]
    },
    {
      text: "General Ledger",
      key: "title.generalLedger",
      level: 1,
      expanded: false,
      items: [
        { level: 2, key: "title.generalJournal", link: "/ledger/general-journal" },
        { level: 2, key: "title.accountReconciliationJournal", link: "/ledger/account-reconciliation-journal" },
        { level: 2, key: "title.generalJournalMasterTemplate", link: "/ledger/general-journal-master-template" },
        { level: 2, key: "title.generalLedgerEntryChangesLogs", link: "/ledger/general-ledger-entry-changes-log" },
      ]
    },
    {
      text: "Inventory",
      key: "title.inventory",
      level: 1,
      expanded: false,
      items: [
        { level: 2, key: "title.item", link: "/inventory/item" },
        { level: 2, key: "data.itemVendorPurchaseprice", link: "/inventory/item-vendor-purchase-price" },
        { level: 2, key: "title.itemJournal", link: "/inventory/item-journal" },
        { level: 2, key: "title.physicalInventoryJournal", link: "/inventory/physical-inventory-journal" },
        { level: 2, key: "title.itemJournalMasterTemplate", link: "/inventory/item-journal-master-template" },
      ]
    },
    {
      text: "Purchasing",
      key: "title.purchasing",
      level: 1,
      expanded: false,
      items: [
        { key: "title.vendor", link: "/payable/vendor", level: 2 },
        { key: "title.purchaseRequest", link: "/payable/purchase-request", level: 2 },
        { key: "title.outstandingPurchaseRequest", link: "/payable/outstanding-purchase-request", level: 2 },
        { key: "title.purchaseOrder", link: "/payable/purchase-order", level: 2 },
        { key: "title.purchaseReceiving", link: "/payable/purchase-receiving", level: 2 },
        { key: "title.purchaseInvoice", link: "/payable/purchase-invoicing", level: 2 },
        { key: "title.purchaseCreditMemo", link: "/payable/purchase-credit-memo", level: 2 },
        { key: "title.paymentJournal", link: "/payable/payment-journal", level: 2 },
        { key: "title.purchaseRequestDetail", link: "/payable/purchase-request-detail", level: 2 },
        { key: "title.purchaseOrderDetail", link: "/payable/purchase-order-detail", level: 2 },
        { key: "title.purchaseReceiptDetail", link: "/payable/purchase-receipt-detail", level: 2 },
        { key: "title.purchaseInvoiceDetail", link: "/payable/purchase-invoice-detail", level: 2 },
        { key: "title.purchaseRequisitionTemplate", link: "/payable/purchase-requisition-template", level: 2 },
      ]
    },
    {
      text: "Store",
      key: "title.store",
      level: 1,
      expanded: false,
      items: [
        { key: "title.storeRequisition", link: "/store/store-requisition", level: 2 },
        { key: "title.outstandingStoreRequisition", link: "/store/outstanding-store-requisition", level: 2 },
        { key: "title.storeRequisitionDetail", link: "/store/store-requisition-detail", level: 2 },
        { key: "title.storeRequisitionTemplate", link: "/store/store-requisition-template", level: 2 },
        { key: "title.interDepartmentTransfer", link: "/store/inter-department-transfer", level: 2 },
        { key: "title.interDepartmentTransferDetail", link: "/store/inter-department-transfer-detail", level: 2 },
      ]
    },
    {
      text: "Receivable",
      key: "title.receivable",
      level: 1,
      expanded: false,
      items: [

        { level: 2, key: "title.client", link: "/receivable/client" },
        { key: "title.salesInvoice", link: "/receivable/sales-invoice", level: 2 },
        { key: "title.receivableInvoice", link: "/receivable/receivable-invoice", level: 2 },
        { key: "title.salesCreditMemo", link: "/receivable/sales-credit-memo", level: 2 },
        { level: 2, key: "title.cashReceiptJournal", link: "/receivable/cash-receipt-journal" },
        { level: 2, key: "title.invoiceEmailLog", link: "/receivable/invoice-email-log" },
      ]
    },
    {
      text: "Posted Document",
      key: "title.postedDocuments",
      level: 1,
      expanded: false,
      items: [
        { key: "title.postedPurchaseReceipt", link: "/posted-documents/posted-purchase-receiving", level: 2 },
        { key: "title.postedPurchaseInvoice", link: "/posted-documents/posted-purchase-invoicing", level: 2 },
        { key: "title.postedPurchaseCreditMemo", link: "/posted-documents/posted-purchase-credit-memo", level: 2 },
        { key: "title.postedStoreRequisition", link: "/posted-documents/posted-store-requisition", level: 2 },

        { key: "title.postedSalesInvoice", link: "/posted-documents/posted-sales-invoice", level: 2 },
        { key: "title.postedSalesCreditMemo", link: "/posted-documents/posted-sales-credit-memo", level: 2 },
      ]
    },
    {
      text: "Entries",
      key: "title.entries",
      level: 1,
      expanded: false,
      items: entry
    },
    {
      text: "Changes Logs",
      key: "title.changesLogs",
      level: 1,
      expanded: false,
      items: [
        { level: 2, key: "title.changesLogs", link: "/changes-logs" },
        { level: 2, key: "title.cancelledPurchaseReceipts", link: "/changes-logs/cancelled-purchase-receipts" },
        { level: 2, key: "title.approvalDocumentWithdrawal", link: "/changes-logs/approval-document-withdrawal" },
      ],
    },
    masterData,
    {
      text: "Document Flow",
      key: "title.documentFlow",
      level: 1,
      expanded: false,
      items: [
        { level: 2, key: "title.masterDocumentFlow", link: "/document-flow/master" },
        { level: 2, key: "title.documentFlowSequenceType", link: "/document-flow/type" },
        { level: 2, key: "title.documentAttachment", link: "/document-flow/document-attachment" },
      ]
    },
    {
      level: 1,
      key: "title.reports",
      text: "All Reports",
      keywords: "reports",
      link: "/reports",
    },
    {
      text: "Integration",
      key: "title.integration",
      level: 1,
      expanded: false,
      items: [
        { key: "title.chartOfAccount", link: "/integration/chart-of-account", level: 2 },
        {
          key: "title.selfBilledInvoice",
          link: "/integration/self-billed-invoice",
          level: 2,
          keywords: "self billed invoice",
        },
        {
          key: "title.taxIntegrationLog",
          link: "/integration/tax-integration-log",
          level: 2,
          keywords: "tax integration log",
        },
      ]
    },
  ],
  // footer links
  footer: [{
    text: "Docs",
    key: "menu.docs",
    href: "https://docs.pms.sentec.io",
    target: "_blank"
  }]
};
